import React, { useState } from 'react';
import { TextInput, Alert,Spinner  } from 'flowbite-react';
import { useEffect } from 'react';
import { login } from '../../../services/authService';
import AuthLayout from '../../../layouts/AuthLayout';
import AuthSeparatorLink from '../components/AuthSeparatorLink';
import SubmitButton from '../components/SubmitButton';
import Label from '../../../components/Label';
import PasswordInput from '../../../components/PasswordInput';
import errorHandler from '../../../utils/errorHandler';
import ShowValidationMessage from '../../../components/ShowValidationMessage';
import Checkbox from '../../../components/Checkbox';
import useAuthRedirect from '../../../hooks/useAuthRedirect';
import useRedirectIfAuthenticated from '../../../hooks/useRedirectIfAuthenticated';
import FullScreenLoader from '../../../components/FullScreenLoader';


const LoginPage = () => {

    // if user is already logged in redirect back to the dashboard
    const isLoadingAuthCheck = useRedirectIfAuthenticated(); 

    const [formData, setFormData] = useState({
        email: '',
        password: '',
        role : 'cpa',
        rememberMe: ''
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [errors, setErrors] = useState({});

    const redirectToUserDashboard = useAuthRedirect(); 


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target; 

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value 

        }));

        setErrors(prev => ({
            ...prev,
            [name]: '',
            general: '' // Clear general error when user types
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        if (validateForm()) {

            try {
              const userData = await login(formData.email, formData.password,formData.role);

              if (userData==null) {
                    setError('Invalid credentials. Please try again.');

              }else{
                redirectToUserDashboard();

              }
            } catch (err) {
                errorHandler(err, setErrors);

                console.error('Login failed:', err);
                setError(err.message || 'Invalid credentials. Please try again.');
            } finally {
                setLoading(false);
            }

        } else {
            setLoading(false);
            console.log('Client-side validation failed.');
        }
    };

    useEffect(() => {
        document.title = 'CPA - Login';
    }, []);

    if (isLoadingAuthCheck) { // If the background auth check is still running
        return <FullScreenLoader />
    }



    const validateForm = () => {
        let newErrors = {};

        if (!formData.email.trim()) {
            newErrors.email = 'Email address is required.';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email address is invalid.';
        }

        if (!formData.password) {
            newErrors.password = 'Password is required.';
        } else if (formData.password.length < 8) {
            newErrors.password = 'Password must be at least 8 characters.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    return (


        <AuthLayout title="CPA - Login">
            {error && (
                <Alert color="failure" onDismiss={() => setError(null)} className="mb-4">
                    <span className="font-medium"></span> {error}
                </Alert>
            )}

            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <div>
                    <div className="mb-2 block">
                        <Label htmlFor="email" label="Email" />
                    </div>

                    <TextInput
                        id="email"
                        type="email"
                        placeholder="you@example.com"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <ShowValidationMessage error={errors.email} />

                </div>
                <div>
                    <div className="mb-2 block">
                        <Label htmlFor="password" label="Password" />
                    </div>
                    <div className="relative">
                        <PasswordInput
                            id="password"
                            name="password"
                            placeholder="••••••••"
                            required
                            value={formData.password}
                            onChange={handleChange}
                            disabled={loading}
                        />
                        <ShowValidationMessage error={errors.password} />


                    </div>
                </div>
                <div className="flex items-center gap-2">

                    <Checkbox
                        id="remember" // Unique ID for the checkbox
                        label="Remember me" // Label text for the checkbox
                        name="rememberMe" // Important: matches the formData key
                        checked={formData.rememberMe} // Controlled by formData state
                        onChange={handleChange} // Use your existing handleChange
                    />


                </div>
                <div className="pt-2">

                    <SubmitButton isLoading={loading} loadingText="Logging In...">
                        Login
                    </SubmitButton>
                </div>


            </form>

            {/* --- Start of "Or" Separator and Link --- */}
            <AuthSeparatorLink
                textDescription="Don't have an account yet? "
                linkText="Signup Now"
                toPath="/signup"
            />

        </AuthLayout>

    );
};

export default LoginPage;